// IO constants.
export const DATA_PATH = 'data/';
export const OUTPUT_PATH = 'output/';
export const TEMP_PATH = 'output/temp/';
export const TOM_HEADER_NUM_BYTES = 512;
export const TOM_DIMENSIONS_START_POSITION = 0;
export const TOM_DIMENSIONS_NUM_BYTES = 6;
export const TOM_DATA_TYPE_START_POSITION = 320;
export const TOM_DATA_TYPE_NUM_BYTES = 10;
export const TOM_NUM_ELEMENTS_MARKER = 'NumEl';
export const TOM_NUM_ELEMENTS_START_POSITION = TOM_DATA_TYPE_START_POSITION + TOM_DATA_TYPE_NUM_BYTES;
export const TOM_NUM_ELEMENTS_NUM_BYTES = TOM_NUM_ELEMENTS_MARKER.length + 1;
export const TOM_USE_NULL_MARKER = 'Null';
export const TOM_USE_NULL_START_POSITION = TOM_NUM_ELEMENTS_START_POSITION + TOM_NUM_ELEMENTS_NUM_BYTES;
export const TOM_USE_NULL_NUM_BYTES = TOM_USE_NULL_MARKER.length + 1;
export const BIN_HEADER_NUM_BYTES = 100;
export const BIN_DIMENSIONS_START_POSITION = 0;
export const BIN_DIMENSIONS_NUM_BYTES = 4;
export const BIN_DATA_TYPE_START_POSITION = BIN_DIMENSIONS_START_POSITION + BIN_DIMENSIONS_NUM_BYTES;
export const BIN_DATA_TYPE_NUM_BYTES = 10;
export const BIN_NUM_ELEMENTS_START_POSITION = BIN_DATA_TYPE_START_POSITION + BIN_DATA_TYPE_NUM_BYTES;
export const BIN_NUM_ELEMENTS_NUM_BYTES = 1;
export const BIN_USE_NULL_START_POSITION = BIN_NUM_ELEMENTS_START_POSITION + BIN_NUM_ELEMENTS_NUM_BYTES;
export const BIN_USE_NULL_NUM_BYTES = 1;
export const MAX_NUM_ELEMENTS = 255;